import { render, staticRenderFns } from "./email_otp_fallback_footer.vue?vue&type=template&id=5b67c163"
import script from "./email_otp_fallback_footer.vue?vue&type=script&lang=js"
export * from "./email_otp_fallback_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports